const coreKeys = {
  recommendations: (...filters: unknown[]) =>
    ["recommendations", ...filters] as const,
  recommendation: (recommendationID: string) =>
    [...coreKeys.recommendations(recommendationID)] as const,
  recommendationTypes: () => [...coreKeys.recommendations("types")] as const,
  recommendationType: (typeID: string) =>
    [...coreKeys.recommendationTypes(), typeID] as const,
};

export default coreKeys;
